export const THREE_TARGET_FPS = 60
export const THREE_FRAME_MS = 1000 / THREE_TARGET_FPS

export const FULLSCREEN_DPR_MAX = 1.5
export const EMBEDDED_DPR_MAX = 1.25

export function getFullscreenDpr(): number {
  if (typeof window === 'undefined') return 1
  return Math.min(window.devicePixelRatio, FULLSCREEN_DPR_MAX)
}

export function getEmbeddedDpr(): number {
  if (typeof window === 'undefined') return 1
  return Math.min(window.devicePixelRatio, EMBEDDED_DPR_MAX)
}

export function shouldRunThreeFrame(now: number, lastFrameMs: number): boolean {
  return now - lastFrameMs >= THREE_FRAME_MS
}
